module.exports = __webpack_public_path__ + "static/img/t1.dd785784.webp";